var React = require('react');

function Like (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.6064 7.76297C33.7562 6.9098 32.7459 6.23285 31.6335 5.77095C30.5212 5.30906 29.3285 5.07129 28.124 5.07129C26.9196 5.07129 25.7269 5.30906 24.6146 5.77095C23.5022 6.23285 22.4919 6.9098 21.6417 7.76297L20.3367 9.08486L19.0318 7.76297C18.1816 6.9098 17.1713 6.23285 16.0589 5.77095C14.9465 5.30906 13.7539 5.07129 12.5494 5.07129C11.3449 5.07129 10.1523 5.30906 9.03992 5.77095C7.92753 6.23285 6.91726 6.9098 6.06705 7.76297C2.47421 11.3558 2.25389 17.423 6.77884 22.0327L20.3367 35.5905L33.8946 22.0327C38.4196 17.423 38.1993 11.3558 34.6064 7.76297Z","fill":"white","stroke":"white","strokeWidth":"3.38947","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Like.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = Like;

Like.default = Like;
